import React from 'react';
import { recordError } from "./utils/commonUtil";

export default class ErrorBoundary extends React.Component {

  componentDidCatch(error, errorInfo) {
    recordError(error, errorInfo);
  }
  render() {
    return this.props.children; 
  }
}